/**
 * Parses the object-shaped JSON that models often wrap in prose or Markdown
 * fences. The caller still owns schema validation; this only removes transport
 * noise around the JSON object.
 */
export function parseJsonObject(content: string): Record<string, unknown> {
  const clean = content.trim().replace(/^\uFEFF/, "");
  const candidates = [
    clean.replace(/^```(?:json)?\s*/i, "").replace(/\s*```$/, "").trim(),
  ];
  const start = clean.indexOf("{");
  const end = clean.lastIndexOf("}");
  if (start >= 0 && end > start) candidates.push(clean.slice(start, end + 1));

  for (const candidate of candidates) {
    try {
      const parsed: unknown = JSON.parse(candidate);
      if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
        return parsed as Record<string, unknown>;
      }
    } catch {
      // Try the next candidate after removing surrounding transport noise.
    }
  }
  throw new Error("JSON oggetto non valido.");
}
